import React from 'react'
import { Table } from '@ccpgames/eve-web-core'
import { Paragraph } from '@/components/shared/typography/Paragraph'
import styles from './renderTable.module.css'

interface TableRowNode {
  content?: Array<{ nodeType: string }>
}

interface TableNode {
  content?: TableRowNode[]
}

function unwrapParagraphInTableCell(children: React.ReactNode): React.ReactNode {
  return React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child
    if (child.type === Paragraph) return <>{(child.props as { children?: React.ReactNode }).children}</>
    return child
  })
}

function getTableHeaderRowCount(tableNode: TableNode): number {
  const rows = tableNode?.content ?? []
  let count = 0
  for (const row of rows) {
    const cells = row?.content ?? []
    const allHeader = cells.length > 0 && cells.every((cell) => cell.nodeType === 'table-header-cell')
    if (allHeader) count++
    else break
  }
  return count
}

export function renderDlpTable(node: unknown, children: React.ReactNode): React.ReactNode {
  const headerRowCount = getTableHeaderRowCount(node as TableNode)
  const rowElements = React.Children.toArray(children)
  const headerRows = rowElements.slice(0, headerRowCount)
  const bodyRows = rowElements.slice(headerRowCount)

  return (
    <div className={styles.tableWrapper}>
      <Table className={styles.table} highlightOnHover>
        {headerRows.length > 0 && (
          <Table.Thead>
            {headerRows.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>{row}</React.Fragment>
            ))}
          </Table.Thead>
        )}
        <Table.Tbody>
          {bodyRows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>{row}</React.Fragment>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  )
}

export function renderDlpTableRow(children: React.ReactNode): React.ReactNode {
  return <Table.Tr>{children}</Table.Tr>
}

export function renderDlpTableHeaderCell(children: React.ReactNode): React.ReactNode {
  return <Table.Th>{unwrapParagraphInTableCell(children)}</Table.Th>
}

export function renderDlpTableCell(children: React.ReactNode): React.ReactNode {
  return <Table.Td>{unwrapParagraphInTableCell(children)}</Table.Td>
}
